export const LAYOUT_CONFIG = {
    ADMIN_NAME: "Mojareklamacija.si",
    COMPANY_DETAILS: {
        SHOW_POINTS: true
    },
    USER_DETAILS: {
        SHOW_POINTS: false
    },
    USE_GESTAL: false,
    LOCALE: "sl"
}